import { combineReducers } from 'redux';
import commonReducer from 'modules/labs/common/reducer';
import accountManagementReducer from 'modules/labs/accountManagement/reducer';
import laboratoriesReducer from 'modules/labs/laboratories/reducer';
import labsOrdersReducer from 'modules/labs/orders/reducer';
import masterListReducer from 'modules/labs/masterList/reducer';

export default combineReducers({
  common: commonReducer,
  accountManagement: accountManagementReducer,
  laboratories: laboratoriesReducer,
  labsOrders: labsOrdersReducer,
  masterList: masterListReducer,
});
